<template>
<section class="content" :key="isActive" style="position: relative;">
    <div :class="addButtonClass" class="common_save_btn">
                <router-link :to="{ name: 'addCity', params: { _id: '0' } }">
                    <button class=" btn gradientbt">+ Add City</button>
                </router-link>
            </div>
    <div v-if="isPasswordRest" class="password-popup">
        <vue-form :state="formstate" class="ui form loginForm" @submit.prevent="checkAndResetPassword">
            <div class="input-group">
                <a class="toggle" v-on:click="isPasswordRest = false">
                    <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 503.021 503.021" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M491.613,75.643l-64.235-64.235c-15.202-15.202-39.854-15.202-55.056,0L251.507,132.222L130.686,11.407

        c-15.202-15.202-39.853-15.202-55.055,0L11.401,75.643c-15.202,15.202-15.202,39.854,0,55.056l120.821,120.815L11.401,372.328

        c-15.202,15.202-15.202,39.854,0,55.056l64.235,64.229c15.202,15.202,39.854,15.202,55.056,0l120.815-120.814l120.822,120.814

        c15.202,15.202,39.854,15.202,55.056,0l64.235-64.229c15.202-15.202,15.202-39.854,0-55.056L370.793,251.514l120.82-120.815

        C506.815,115.49,506.815,90.845,491.613,75.643z" />
                            </g>
                        </g>
                    </svg>
                </a>
                <h2>Reset Password</h2>
                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.newPassword)">
                    <label>Password</label>
                    <input class="form-control" name="newPassword" id="password" placeholder="Enter Password" type="password" v-model="newPassword" required pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$#!%*?&]{8,}$" />
                    <field-messages name="newPassword" show="$touched || $submitted" class="form-control-feedback error-message">
                        <p slot="required">Password is a required field</p>
                        <div slot="pattern">
                            Password should have at least one uppercase letter, one
                            lowercase letter, one number and one special character. ( eg:
                            Xyz@1234 )
                        </div>
                    </field-messages>
                </validate>
            </div>
            <div class="input-group">
                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.passwordVerify)">
                    <label>Confirm Password</label>
                    <input class="form-control" name="passwordVerify" id="passwordVerify" placeholder="Enter Confirm password" type="password" v-on:input="isPasswordMatch" v-model="passwordVerify" required pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$#!%*?&]{8,}$" />
                    <field-messages name="passwordVerify" show="$touched || $submitted" class="form-control-feedback error-message">
                        <div slot="required">Confirm password is a required field</div>
                        <div slot="pattern">
                            Password should have at least one uppercase letter, one
                            lowercase letter, one number and one special character. ( eg:
                            Xyz@1234 )
                        </div>
                    </field-messages>
                </validate>
            </div>
            <div class="col-sm-12 showPassword">
                <input type="checkbox" v-on:click="showPassword" /><span>Show Password</span>
            </div>
            <div class="form-actions resetPasswordButton">
                <button type="submit" :disabled="isResetPasswordDisabled" v-bind:class="'btn btn-warning btn-lg resetPasswordButton' + loading">
                    Reset Password
                </button>
            </div>
        </vue-form>
    </div>

    <!-- <button @click="refreshTable">uppppp</button> -->

    <div v-on:click="closeResetPasswordModal" class="city_wrp_res">
        <div class="box-body">
            <!-- <div :class="addButtonClass">
                <router-link :to="{ name: 'addCity', params: { _id: '0' } }">
                    <button class=" btn gradientbt">Add City</button>
                </router-link>
            </div> -->

            <v-server-table ref="cityTable" url :limit="5" :columns="columns" :options="options" v-model="data" @loaded="onLoaded">
                <template slot="beforeBody">
                    <tr v-if="loading" class="VueTables__no-results">
                        <td class="text-center" colspan="6">
                            <pulse-loader></pulse-loader>
                        </td>
                    </tr>
                </template>
                <template slot="action" slot-scope="props">
                    <div class="active_wrp">
                        <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                        <a class="fa fa-key" role="button" v-on:click.stop="password(props.row)"></a>
                        <div class="py-2 text-center row">
                            <label class="toggle">
                                <input class="toggle-checkbox" type="checkbox" :checked="props.row.status === true ? true : false" @click.prevent="(e) => activateCityModal(props.row)" />
                                <span class="slider"></span>
                                <!-- <span class="labels" data-on="Active" data-off="Deactivate"></span> -->
                            </label>
                        </div>
                    </div>
                </template>
            </v-server-table>
        </div>
    </div>
</section>
</template>

<script>
import {
    cityService,
    formService
} from "../../../services";
import {
    eventBus
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";

import {
    authService
} from "../../../services";
import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import CityPassword from "./cityPassword.vue";
import dateFormatter from "../../utilities/dateFormate";
export default {
    components: {
        CityPassword,
    },
    name: "city",
    data() {
        return {
            show: true,
            isResetPasswordDisabled: true,
            userId: "",
            newPassword: "",
            passwordVerify: "",
            formstate: {},
            isPasswordRest: false,
            isActive: true,
            loading: null,
            data: {},
            USER_ROLES: USER_ROLES,
            cityTable: null,
            params: {},
            columns: [
                "cityName",
                "firstName",
                "lastName",
                "email",
                "mobile",
                "createdAt",
                "action",
            ],
            options: {
                highlightMatches: true,
                headings: {
                    cityName: "City",
                    firstName: " Admin First Name",
                    lastName: " Admin Last Name",
                    email: "Email",
                    mobile: "Contact",
                    createdAt: "Created On",
                    action: "Action",
                },
                templates: {
                    status(row, query) {
                        return query.status[0].toUpperCase() + query.status.slice(1);
                    },
                    createdAt(row, query) {
                        return dateFormatter(query.createdAt);
                        // return moment(query.createdAt).format("DD-MM-YYYY");
                    },
                    lastName(row, query) {
                        if (!query.lastName) {
                            return "NA";
                        } else {
                            return query.lastName;
                        }
                    },
                },
                perPage: 10,
                sortable: [
                    "cityName",
                    "firstName",
                    "lastName",
                    "email",
                    "mobile",
                    "createdAt",
                ],
                requestFunction: (request) => {
                    const params = {};
                    params.page = request.page;
                    params.limit = request.limit;
                    params.sortBy = "createdAt";
                    params.sortOrder = "des";
                    if (request.orderBy) {
                        if (
                            request.orderBy === "firstName" ||
                            request.orderBy === "lastName" ||
                            request.orderBy === "mobile" ||
                            request.orderBy === "email"
                        ) {
                            params.sortBy = "user." + request.orderBy;
                        } else {
                            params.sortBy = request.orderBy;
                        }
                        if (request.ascending == 1) {
                            params.sortOrder = "asc";
                        } else {
                            params.sortOrder = "des";
                        }
                    }

                    if (request.query != "") {
                        // if(request.query.length < 3) return;
                        params.searchString = request.query;
                    }

                    this.loading = true;
                    return this.$cityRepository
                        .collectionAreaList(params)
                        .catch((error) => {
                            console.error("Users.requestFunction-error:", error);
                            this.$snotify.error("City List Not Found !, Error");
                        });
                },
                responseAdapter: (response) => {
                    this.loading = false;
                    let dataResp = [];
                    let count;
                    response.data.docs.forEach((element) => {
                        let finalData = element;

                        finalData["cityName"] = element.cityName;
                        // finalData["firstName"] = element.user.firstName;
                        // finalData["lastName"] = element.user.lastName;
                        // finalData["email"] = element.user.email;
                        // finalData["mobile"] = element.user.mobile;
                        // finalData["createdAt"] = element.createdAt;

                        finalData["firstName"] =
                            element.user != null ? element.user.firstName : null;
                        finalData["lastName"] =
                            element.user != null ? element.user.lastName : null;
                        finalData["email"] =
                            element.user != null ? element.user.email : null;
                        finalData["mobile"] =
                            element.user != null ? element.user.mobile : null;
                        finalData["createdAt"] =
                            element.user != null ? element.user.createdAt : null;

                        dataResp.push(finalData);
                    });
                    if (dataResp.length === 0) {
                        count = 0;
                    }
                    return {
                        data: response.data.docs,
                        count: response.data.items.total || count,
                    };
                },

                customFilters: [{
                    name: "mysearch",
                    callback: function (row, query) {
                        return row.cityName[0] == query;
                    },
                }, ],
                uniqueKey: "_id",
                search: "",
            },
        };
    },

    // watch: {
    //       options: {
    //         handler () {
    //           this.getDataFromApi()
    //             .then(data => {
    //               this.desserts = data.items
    //               this.totalDesserts = data.total
    //             })
    //         },
    //         deep: true,
    //       },
    //     },

    computed: {
        addButtonClass() {
            if (this.cityTable) {
                return this.cityTable.count > this.cityTable.limit ||
                    this.cityTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        fieldClassName: formService.fieldClassName,

        isPasswordMatch(){
            const valid = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$#!%*?&]{8,}$/);
            if(valid.test(this.newPassword)){
                this.newPassword == this.passwordVerify ? (this.isResetPasswordDisabled = false) : (this.isResetPasswordDisabled = true);
            }      
        },
        searchItem(event) {
            this.$refs.cityTable.data.splice(0, this.$refs.cityTable.data.length);
            let item = event.target.value;
            return cityService
                .citysearch(this.params, item)
                .then((response) => {
                    this.$refs.cityTable.data = [];
                    let finalData;
                    this.headings = {
                        cityName: "City Name",
                        firstName: "City Admin First Name",
                        lastName: "City Admin Last Name",
                        email: "Email",
                        mobile: "Mobile",
                        createdAt: "Created On",
                        action: "Action",
                    };
                    response.data.response.forEach((element) => {
                        finalData = element;
                        finalData["cityName"] = element.cityName;
                        finalData["firstName"] = element.user.firstName;
                        finalData["lastName"] = element.users.lastName;
                        finalData["email"] = element.users.email;
                        finalData["mobile"] = element.users.mobile;
                        finalData["createdAt"] = element.users.createdAt;
                        this.$refs.cityTable.data.push(finalData);
                    });
                    this.$refs.cityTable.count = response.data.response.length;
                })
                .catch((error) => {
                    this.$refs.cityTable.refresh();
                });
        },
        closeResetPasswordModal() {
            if (this.isPasswordRest) {
                this.isPasswordRest = !this.isPasswordRest;
            }
        },

        showPassword() {
            let x = document.getElementById("password");
            let y = document.getElementById("passwordVerify");
            if (x.type === "password" && y.type === "password") {
                x.type = "text";
                y.type = "text";
            } else {
                x.type = "password";
                y.type = "password";
            }
        },

        checkAndResetPassword() {
            if (this.newPassword !== this.passwordVerify) {
                this.loading = false;
                this.$snotify.error(`New Password and Confirm Password must be Same`);
                return;
            }
            authService
                .resetPasswordAdmin(this.email, this.newPassword, this.passwordVerify)
                .then((response) => {
                    this.loading = false;
                    this.$snotify.success(`Password has been reset successfully`);
                    this.isPasswordRest = !this.isPasswordRest;
                    this.newPassword = "";
                    this.passwordVerify = "";
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("user.resetpassword:", error);
                    this.flash = true;
                    this.flashType = "error";
                    if (error.data.message === "Invalid Password .") {
                        this.flashMessage = error.data.message;
                    } else if (error.data.message === "Account is inactive.") {
                        this.accountActive = false;
                        this.flashType = "info";
                        this.flashMessage =
                            "You need to activate your account. Please enter your email address and " +
                            "click the link below to resend an activation email.";
                    } else if (error.data.message === "Account is disabled.") {
                        this.flashMessage =
                            "Your account has been disabled. Please contact the SuperAdmin " +
                            "to enable your account.";
                    } else if (error.data.message === "Account is deleted.") {
                        this.flashMessage = "This account has been deleted";
                    } else if (
                        error.data.message ===
                        "Maximum number of auth attempts reached. Please try again later."
                    ) {
                        this.flashMessage = error.data.message;
                    } else {
                        this.flashMessage =
                            "There was an error logging in, please try again.";
                    }
                });
        },

        activateCityModal(row) {
            let confirmtext;
            if (row.status === false) {
                confirmtext = "Active";
            } else {
                confirmtext = "Deactive";
            }
            swal({
                // title: "Are you sure?",
                title: `Are you sure you want to ${confirmtext}?`,
                // text: `Are you sure you want to ${confirmtext}?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#35A2FE",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${confirmtext}`,
            }).then((result) => {
                if (result.value) {
                    this.activateCity(row);
                }
            });
        },
        activateCity(row) {
            let confirmtext;
            let status;
            if (row.status === false) {
                confirmtext = "Active";
                status = true;
            } else {
                confirmtext = "Deactive";
                status = false;
            }
            this.loading = true;

            let updatedCity = {
                status: status,
                cityId: row._id,
                cityName: row.cityName,
                email: row.email,
                firstName: row.firstName,
                lastName: row.lastName,
                mobile: row.mobile + "",
            };
            return cityService
                .updateCity(updatedCity)
                .then((response) => {
                    this.loading = false;
                    row.status = !row.status;
                    this.$snotify.success(
                        `The ${row.cityName} has been marked ${confirmtext}.`
                    );
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("City.activateCity-error:", error);
                    this.$snotify.error("Activate user failed", "Error!");
                });
        },
        action(row) {
            this.$router.push({
                name: "addCity",
                params: {
                    _id: row._id,
                },
                props: row,
            });
            // getCurrentLoggedinUserRank() {
            //     return store.state.auth.user.role.rank;
            // },
            // rowClick(data) {

            //     // if (store.state.auth.user.role.rank <= data.row.role.rank) {
            //     this.$router.push({
            //         name: 'addCity',
            //         params: {
            //             _id: data.row._id,
            //         },
            //         props: data.row,
            //     });
            // } else {
            //     this.$snotify.error('You can`t update this user', 'Access Denied!');
            // }
        },
        password(row) {
            this.newPassword = "";
            this.passwordVerify = "";
            this.isPasswordRest = !this.isPasswordRest;
            this.userId = row.user._id;
            this.email = row.email;

            // this.checkAndResetPassword() ;
            // this.$router.push({
            //     name: 'cityPassword',
            //     params: {
            //         _id: row._id,
            //     },
            //     props: row,
            // });
        },
        onLoaded() {
            this.cityTable = this.$refs.cityTable;
        },
        clearFilter() {
            this.custom_filter_select = "";
        },
        applyFilter(filter_val) {
            Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
        },
        toggle(row) {
            this.isActive = !this.isActive;
            let city = {
                cityId: row._id,
                cityName: row.cityName,
                email: row.email,
                firstName: row.firstName,
                lastName: row.lastName,
                mobile: row.mobile,
                status: row.status === "active" ? "inactive" : "active",
            };
            cityService
                .updateCity(city)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success("status updated", "Success!");
                    this.$router.push("/city");
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("CityDetails.updateCity-error:", error);
                    this.$snotify.error("Update status failed", "Error!");
                    if (error.data.message.includes("must be one of")) {
                        this.flash = true;
                        this.flashType = "error";
                        this.flashMessage =
                            "That city name is not allowed. You must first update the list of allowed city names" +
                            " in the appy client and server config.";
                    }
                });
        },
        checkStatus(status) {
            return status === "inactive" ? false : true;
        },
    },
    onLoaded() {
        this.userTable = this.$refs.cityTable;
    },
    mounted() {
        eventBus.$on("DATA_PUBLISHED", (payload) => {});
        // eventBus.$on('refresh-table', this.cityTable)
    },
    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },
};
</script>

<style scoped>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.active_wrp {
    display: flex;
    align-items: center;
    width: 140px;
}

.active_wrp a {
    flex: 0 0 25%;
    color: #35A2FE;
    margin-right: 5px;
}

.gradientbt {
    color: white;
    background: #35A2FE;
}

.toggle-switch {
    display: inline-block;
    background: #ccc;
    border-radius: 16px;
    width: 58px;
    height: 32px;
    position: relative;
    vertical-align: middle;
    transition: s 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
    content: "";
}

.toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    width: 24px;
    height: 24px;
    position: absolute;
    top: 4px;
    left: 4px;
    transition: left 0.25s;
}

.toggle:hover .toggle-switch:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}

.toggle-checkbox:checked+.toggle-switch {
    background: #56c080;
}

.toggle-checkbox:checked+.toggle-switch:before {
    left: 30px;
}

.toggle-checkbox {
    position: absolute;
    visibility: hidden;
}

.toggle-label {
    margin-left: 5px;
    position: relative;
    top: 2px;
}

.password-popup {
    height: 100%;
    width: 100%;
    z-index: 10;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    text-align: center;
    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    z-index: 9999;
    background-color: rgb(0 0 0 / 50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.password-popup-center {
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 70%;
}

.loginForm {
    padding-top: 0px;
}

.loginForm {
    padding-top: 0px;
    background: #fff;
    width: 500px;
    height: 300px;
    padding: 20px;
    border-radius: 10px;
}

.password-popup h2 {
    margin: 0;
    font-size: 24px;
    margin-bottom: 20px;
    text-align: center;
}

.loginForm .input-group input {
    background: transparent;
    border: 2px solid #727070;
    height: 4rem;
}

.loginForm {
    position: relative;
    height:auto;
    width: 46%;
}

.loginForm .input-group .toggle {
    position: absolute;
    right: -5px;
    top: -4px;
    background: transparent;
    border: 0;
    box-shadow: none;
    width: auto;
}

.loginForm .input-group .toggle svg {
    width: 20px;
    height: 20px;
}

.error-message {
    width: 100%;
    text-align: left;
    margin-top: 35px;
}

.required {
    color: red;
}

.showPassword {
    margin-left: 0;
    font-size: medium;
    text-align: left;
    padding: 0;
}

.showPassword input {
    margin-right: 10px;
    height: 17px;
    width: 17px;
    display: inline-block;
    position: relative;
    top: 3px;
}

.resetPasswordButton {
    /* margin-left: 00px; */
    margin-top: 41px;
}


@media(max-width:767px){
    .city_wrp_res .gradientbt{
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// city.vue?1222f140